function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_487",
  "data-name": "Rechteck 487",
  width: 60.81,
  height: 66.649,
  fill: "none",
  stroke: "#009fe3",
  strokeWidth: 2
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_3632",
  "data-name": "Gruppe 3632",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1330",
  "data-name": "Pfad 1330",
  d: "M16.424,34.778l-.258-4.846H12.482",
  transform: "translate(1.745 4.443)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_1658",
  "data-name": "Gruppe 1658",
  transform: "translate(0 0.001)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_1657",
  "data-name": "Gruppe 1657",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1331",
  "data-name": "Pfad 1331",
  d: "M55.792,63.656V38.982H13.766m.676,13.237L13.158,24.485h-8.4l-1.8,39.171m30.625-11.9h-7.8V43.953h7.8Zm13.945,0h-7.8V43.953h7.8Z",
  transform: "translate(0.231 1.915)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Linie_36",
  "data-name": "Linie 36",
  x2: 59.156,
  transform: "translate(0 65.571)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1332",
  "data-name": "Pfad 1332",
  d: "M16.884,18.749H42.52A7.684,7.684,0,0,0,50,10.895,7.68,7.68,0,0,0,42.52,3.041a7.044,7.044,0,0,0-2.008.286A8.139,8.139,0,0,0,28.9,3.553a7.087,7.087,0,0,0-2.671-.512,7.292,7.292,0,0,0-5.405,2.424C18.5,5.791,8.633,6.909,8.633,21.948A12.343,12.343,0,0,1,16.884,18.749Z",
  transform: "translate(0.675 0.078)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1333",
  "data-name": "Pfad 1333",
  d: "M21.031,18.06A19.535,19.535,0,0,0,18.886,27.8a11.734,11.734,0,0,1,7.851-3.046h24.4a7.31,7.31,0,0,0,7.121-7.473,7.312,7.312,0,0,0-7.121-7.476,6.771,6.771,0,0,0-1.908.273",
  transform: "translate(1.478 0.767)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinejoin: "round",
  strokeWidth: 2
}))));

function SvgPersona3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60.81,
    height: 66.649,
    viewBox: "0 0 60.81 66.649",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersona3);
export default __webpack_public_path__ + "static/media/persona3.0a851ad4.svg";
export { ForwardRef as ReactComponent };